import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = [
  {
    id: null,
    item: null,
    qty: 0,
    rate: 0,
    type: "",
    total: 0,
    note: "",
    Dis:0,
    deliveryDate: dayjs().format(),
  },
];

const quotationSlice = createSlice({
  name: "quotationTable",
  initialState,
  reducers: {
    // Update a specific row in the table
    UPDATE_TABLE_ROW(state, action) {
      const { index, qty, rate, ...fields } = action.payload;
      if (state[index]) {
        // Update the row with new fields
        Object.assign(state[index], fields);

        // Update `qty` and `rate` if provided
        if (qty !== undefined) state[index].qty = qty;
        if (rate !== undefined) state[index].rate = rate;

        // Recalculate the `total` field
        state[index].total = (state[index].qty * state[index].rate)-(state[index].Dis|| 0);
      }
    },

    // Add a new row to the table
    ADD_QUOTATION_TABLE_ROW(state, action) {
      state.push({
        id: null,
        item: null,
        qty: 0,
        rate: 0,
        type: "",
        total: 0,
        note: "",
        deliveryDate: dayjs().format(),
      });
    },

    // Remove a row from the table
    REMOVE_QUOTATION_TABLE_ROW(state, action) {
      const { index } = action.payload;
      if (state[index]) {
        state.splice(index, 1);
      }
    },

    // Reset the table to the initial state
    RESET_QUOTATION_TABLE() {
      return initialState;
    },

    // Replace the entire table with new data
    REPLACE_QUOTATION_TABLE(state, action) {
      return [...action.payload];
    },
  },
});

export const {
  UPDATE_TABLE_ROW,
  ADD_QUOTATION_TABLE_ROW,
  REMOVE_QUOTATION_TABLE_ROW,
  RESET_QUOTATION_TABLE,
  REPLACE_QUOTATION_TABLE,
} = quotationSlice.actions;

export default quotationSlice.reducer;
